import AboutIntroduction from './about-introduction';

export default class AboutIntroductionDesktop extends AboutIntroduction {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/about-introduction/about-introduction.desktop.js